import React, { useEffect, useState,useCallback ,useMemo} from "react";
import Sidebar from "./Sidebar";
import { useSidebar } from "../hooks";
import { API_BASE_URL } from "../config";
import { Session } from "./utils/session";

export default function NotificationList() {

  const { toggleSidebar } = useSidebar();
  const [notifications, setNotifications] = useState([]);
  const [workspaces, setWorkspaces] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

 const authHeaders = useMemo(() => ({
  Authorization: `Bearer ${Session.getToken()}`,
  "Content-Type": "application/json"
}), []);

 const loadNotifications = useCallback(async () => {
  try {
     setLoading(true);
    const res = await fetch(
      `${API_BASE_URL}/api/notifications/Notificationlist`,
      { headers: authHeaders }
    );
    if (!res.ok) throw new Error("Notification API failed");
    const data = await res.json();
    setNotifications(Array.isArray(data) ? data : []);
  }  catch (err) {
    console.error("Notification load error:", err);
  } finally {
    setLoading(false);
  }
}, [authHeaders]);

const loadWorkspaces = useCallback(async () => {
  try {
    const res = await fetch(
      `${API_BASE_URL}/api/Workspace/Workspaces_List`,
      { headers: authHeaders }
    );
    if (!res.ok) throw new Error("Workspace API failed");
    const data = await res.json();
    setWorkspaces(Array.isArray(data) ? data : []);
  } catch (err) {
    console.error("Workspace load error:", err);
  }
}, [authHeaders]);

  useEffect(() => {
    loadNotifications();
    loadWorkspaces();
  }, [loadNotifications, loadWorkspaces]);


  const handleTeamChange = (id) => {
    setSelectedTeams((prev) => {
      if (prev.includes(id)) {
        return prev.filter((x) => x !== id);
      }
      return [...prev, id];
    });
  };

const handleCreate = async () => {
  setError("");

  if (!selectedTeams.length) {
    setError("Please select at least one team");
    return;
  }
  if (!message.trim()) {
    setError("Please enter message");
    return;
  }

  try {

    setLoading(true);

    const payload = {
      workspaceIds: selectedTeams,  
      message: message,
      loginUserID:null 
    };
    const res = await fetch(
      `${API_BASE_URL}/api/Notifications/create`,
      {
        method: "POST",
        headers: authHeaders,
        body: JSON.stringify(payload)
      }
    );

    if (!res.ok) throw new Error("Create failed");

    await loadNotifications();
    setSelectedTeams([]);
    setMessage("");
    setShowForm(false);

  } catch (err) {

    console.error(err);
    setError("Failed to create notification");

  } finally {
    setLoading(false);
  }
};

  return (
    <div>

      <div id="sidebar-overlay" />
      <Sidebar />
      <div id="content">
        <div className="d-flex align-items-center mb-2">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-toggle me-3"
            onClick={toggleSidebar}
          >
            <i className="fas fa-bars" />
          </button>
          <span className="text-muted small">
            <i className="fas fa-chevron-left" /> Back
          </span>
        </div>
        <h2 className="mb-4 fw-bold">Notifications</h2>

        <div className="main-card">
          <div className="panel panel-default">
            <div className="panel-body p-4">
                 {loading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
          <img src="/Images/loader.gif" alt="loading" style={{ width: "80px" }} />
        </div>
      ) : (
      <>
              {!showForm && (
                <>
                  <div className="d-flex justify-content-end mb-3">
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                      setError("");
                      setShowForm(true);
                    }}

                    >
                      + Create Notification
                    </button>
                  </div>
                  <table className="table table-custom table-hover">
                    <thead>
                      <tr>
                        <th>Sr No</th>
                        <th>Team</th>
                        <th>Message</th>
                        <th>Date</th>
                        <th>Users</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!notifications.length && (
                        <tr>
                          <td colSpan="5" className="text-center text-muted py-3">
                            No Notifications Found
                          </td>
                        </tr>
                      )}

                      {notifications.map((item, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{item.teams}</td>
                          <td style={{
                            maxWidth:"500px",
                            lineHeight:"1.5",
                            maxHeight:"4.5em",
                            overflow:"hidden",
                            whiteSpace:"normal",
                            wordBreak:"break-word"
                          }}>
                            {item.message}
                          </td>
                          <td>
                            {new Date(item.createdDate).toLocaleDateString()}
                          </td>
                          <td>{item.totalUsers}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}

              {showForm && (
                <div className="mb-0 p-4">
                  <h4 className="mb-3">Create Notification</h4>
                  {error && (
                    <div className="alert alert-danger">{error}</div>
                  )}
                  <div className="px-4 pt-2">
                    <div className="row">

                      <div className="form-group col-md-12 mb-3">
                        <label>Select Teams</label>
                        <div className="d-flex flex-wrap gap-3">
                          {workspaces.map((w) => {
                            const id = Number(
                              w.workspaceID || w.WorkspaceID
                            );
                            return (
                              <div key={id} className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id={`team_${id}`}
                                  checked={selectedTeams.includes(id)}
                                  onChange={() => handleTeamChange(id)}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`team_${id}`}
                                >
                                  {w.workspaceName || w.WorkspaceName}
                                </label>
                              </div>
                            );
                          })}
                        </div>
                      </div>

                      <div className="form-group col-12 mb-3">
                        <label>Message</label>
                        <textarea
                          className="form-control"
                          rows="4"
                          placeholder="Type message..."
                          value={message}
                          onChange={(e) => setMessage(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-12 mt-3 d-flex px-4"
                    style={{ gap: 8 }} >
                    <button
                      type="button"
                      className="btn btn-primary"
                      disabled={loading}
                      onClick={handleCreate}
                    >
                      {loading ? "Sending..." : "Create"}
                    </button>

                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setShowForm(false)} >
                      Cancel
                    </button>

                  </div>
                </div>
              )}
              </>   
)}   
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

